import { IConditionals, IParams } from 'types';
import { validExpression } from 'utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const math = require('mathjs-expression-parser');

const checkCondition = (expression: string, params: IParams) => {
  if (params == null) return true;

  let res;
  try {
    res = math.eval(validExpression(expression), params);
  } catch {
    res = false;
  }
  return res;
};

export const checkConditionals = (conditions: IConditionals, params: IParams) => {
  let expCount = 0;
  if (conditions !== undefined && conditions !== null) {
    const keys = conditions.expressionList;
    const keepChecking = true;
    let valid = false;
    let validityString = '';
    let validity = false;

    keys.forEach((key: string | number) => {
      if (keepChecking) {
        const exp = conditions.expressions[key].expression;
        valid = checkCondition(exp, params);
        validityString += valid.toString();
        if (expCount < keys.length - 1) {
          switch (conditions.expressions[key].operator) {
            case 'OR':
              validityString += ' or ';
              break;
            case 'AND':
              validityString += ' and ';
              break;
            default:
          }
        }
        // eslint-disable-next-line no-plusplus
        expCount++;
      }
    });

    validity = checkCondition(validityString, params);
    return validity;
  }

  return false;
};
